import { call, put } from "@redux-saga/core/effects";
import i18n from "../../../i18n/i18n";
import { getSuccessToast } from "../../../util/toasts";
import {
  // COMFACT - KOMMER ATT TAS BORT 
  // GET_ALLOWED_CONTRACTS,
  GET_ALL_CAREPRINCIPALS,
  GET_CARE_PRINCIPAL_ACCESS,
  GET_CARE_UNIT_SETTINGS,
  GET_JOBS_CONFIGURATIONS,
  GET_SETTINGS_FILE_NAMES,
  setAllCarePrincipals,
  // COMFACT - KOMMER ATT TAS BORT 
  // setAllowedContracts,
  setCarePrincipalAccess,
  setCarePrincipalIds,
  setCarePrincipalsSettings,
  setCareUnitSettings,
  setConnectedCarePrincipals,
  setJobsConfigurations,
  setPuNames,
  setSettingsFileNames,
} from "../../reducers/administrationReducer";
import {
  setCarePrincipalForm,
  setSelectedCarePrincipal,
} from "../../reducers/loginReducer";
import confirmSaga from "./modalSagas";
import {
  CarePrincipalAdministrationApi,
  CarePrincipalApi,
} from "../../../generated/api";
import { getAPIConfig } from "../../../util/api-config";
import store from "../../configureStore";
import { handleError } from "../../../util/errorHandler";
import { toast } from "react-toastify";
import { MODAL_CONFIRM } from "../../reducers/modalReducer";

export function* handleUpdateCarePrincipalAccessModal(action: any): any {
  try {
    yield call(confirmSaga, action.modalType);
  } catch (error) {
   yield handleError(error);
  }
}

export function* handleGetCareUnitSettings(action: any): any {
  try {
    const carePrincipalAdminClient = setUpClient();
    const careUnitId = action?.careUnitId ? action.careUnitId : "NA";
    const response = yield carePrincipalAdminClient.getCareUnitSettings(
      careUnitId
    );
    if (response) {
      yield put(setCareUnitSettings(response));
      if (response?.id === undefined) {
        yield put(setSelectedCarePrincipal(action.carePrincipals[0]));
        yield put(setCarePrincipalForm(action.carePrincipals[0]));
      } else {
        const selectedCarePrincipal = action.carePrincipals.find(
          (x: any) => x.id === response.carePrincipalId
        );
        yield put(
          setSelectedCarePrincipal(
            selectedCarePrincipal
              ? selectedCarePrincipal
              : action.carePrincipals[0]
          )
        );
        yield put(
          setCarePrincipalForm(
            selectedCarePrincipal
              ? selectedCarePrincipal
              : action.carePrincipals[0]
          )
        );
      }
    }
  } catch (error) {
   yield handleError(error);
  }
}

export function* handleGetCarePrincipalIdFromCurrentUser(action: any): any {
  try {
    const carePrincipalAdminClient = setUpCarePrincipalClient();
    const response =
      yield carePrincipalAdminClient.getCarePrincipalsForAuthorizedEntity(
        action.healthCareProviderId
      );

    yield put(setCarePrincipalIds(response));
  } catch (error) {
   yield handleError(error);
  }
}

function setUpClient() {
  return new CarePrincipalAdministrationApi(
    getAPIConfig(store.getState().settings.internalSettings)
  );
}

function setUpCarePrincipalClient() {
  return new CarePrincipalApi(
    getAPIConfig(store.getState().settings.internalSettings)
  );
}

export function* handleGetAllCarePrincipals(): any {
  try {
    const carePrincipalClient = setUpCarePrincipalClient();
    const response = yield carePrincipalClient.getAllCarePrincipals();

    yield put(setAllCarePrincipals(response));
  } catch (error) {
   yield handleError(error);
  }
}

export function* handleAddCarePrincipal(action: any): any {
  try {
    const carePrincipalClient = setUpCarePrincipalClient();
    yield carePrincipalClient.addCarePrincipal(action.carePrincipal);

    yield put({ type: GET_ALL_CAREPRINCIPALS });
    toast.success(
      String(i18n.t("toasts.carePrincipalAdded", { name: action?.carePrincipal?.name }))
    );
  } catch (error) {
   yield handleError(error);
  }
}

export function* handleUpdateCarePrincipal(action: any): any {
  try {
    const carePrincipalClient = setUpCarePrincipalClient();
    yield carePrincipalClient.updateCarePrincipal(
      action.carePrincipal.id,
      action.carePrincipal
    );

    yield put({ type: GET_ALL_CAREPRINCIPALS });
    toast.success(
      String(i18n.t("toasts.carePrincipalUpdated", {
        name: action?.carePrincipal?.name,
      }))
    );
  } catch (error) {
   yield handleError(error);
  }
}

export function* handleDeleteCarePrincipalModal(action: any): any {
  try {
    const isConfirmed = yield call(confirmSaga, "delete");
    if (isConfirmed) {
      yield call(handleDeleteCarePrincipal, action);
    }
  } catch (error: any) {
   yield handleError(error);
  }
}

export function* handleDeleteCarePrincipal(action: any): any {
  try {
    const carePrincipalClient = setUpCarePrincipalClient();
    yield carePrincipalClient.removeCarePrincipal(action.carePrincipalId);
    toast.success(
      String(i18n.t("toasts.carePrincipalDeleted", {
        name: action?.carePrincipal?.name,
      }))
    );
    yield put({ type: GET_ALL_CAREPRINCIPALS });
  } catch (error) {
   yield handleError(error);
  }
}

export function* handleGetSettingsFileNames(): any {
  try {
    const carePrincipalAdminClient = setUpClient();
    const response = yield carePrincipalAdminClient.getAllSettingsFiles();
    yield put(setSettingsFileNames(response));
  } catch (error) {
   yield handleError(error);
  }
}

export function* handleSaveSettingsFile(action: any): any {
  try {
    const carePrincipalAdminClient = setUpClient();
    yield carePrincipalAdminClient.saveSettingsFile(action.file);
    yield put({ type: GET_SETTINGS_FILE_NAMES });
    getSuccessToast(String(i18n.t("toasts.fileAdded")));
  } catch (error) {
   yield handleError(error);
  }
}

export function* handleUpdateCarePrincipalAccess(action: any): any {
  try {
    const carePrincipalAdminClient = setUpClient();
    yield carePrincipalAdminClient.updateCarePrincipalAccess(
      action.carePrincipalId,
      action.updatedAccess.id,
      action.updatedAccess
    );
    yield put({
      type: GET_CARE_PRINCIPAL_ACCESS,
      carePrincipalId: action.carePrincipalId,
    });
    yield put({ type: MODAL_CONFIRM });
    getSuccessToast(String(i18n.t("toasts.carePrincipalAccessUpdated")));
  } catch (error) {
   yield handleError(error);
  }
}

export function* handleDeleteCarePrincipalAccessModal(action: any): any {
  try {
    yield call(confirmSaga, action.modalType);
  } catch (error) {
   yield handleError(error);
  }
}

export function* handleUpdateCarePrincipalSettings(action: any): any {
  try {
    const carePrincipalAdminClient = setUpClient();
    yield carePrincipalAdminClient.updateCarePrincipalSettings(
      action.carePrincipalId,
      action.form
    );
    yield put({
      type: GET_JOBS_CONFIGURATIONS,
      carePrincipalId: action.carePrincipalId,
    });
    getSuccessToast(String(i18n.t("toasts.jobSettingsUpdated")));
  } catch (error) {
   yield handleError(error);
  }
}

// COMFACT - KOMMER ATT TAS BORT 
// export function* handleGetAllowedContracts(action: any): any {
//   try {
//     const carePrincipalAdminClient = setUpClient();
//     const response = yield carePrincipalAdminClient.getAllowedContracts(
//       action.carePrincipalId
//     );
//     yield put(setAllowedContracts(response));
//   } catch (error) {
//    yield handleError(error);
//   }
// }

export function* handleGetPuNames(): any {
  try {
    const carePrincipalAdminClient = setUpClient();
    const response = yield carePrincipalAdminClient.getPuServices();
    yield put(setPuNames(response));
  } catch (error) {
   yield handleError(error);
  }
}

export function* handleGetJobsConfiguration(action: any): any {
  try {
    const carePrincipalAdminClient = setUpClient();
    const response =
      yield carePrincipalAdminClient.getJobsConfigurationForCarePrincipal(
        action.carePrincipalId
      );
    yield put(setJobsConfigurations(response));
  } catch (error) {
   yield handleError(error);
  }
}

export function* handleUpdateJobsConfiguration(action: any): any {
  try {
    const carePrincipalAdminClient = setUpClient();
    yield carePrincipalAdminClient.updateJobsConfigurationsByCardType(
      action.carePrincipalId,
      action.form
    );
    yield put({
      type: GET_JOBS_CONFIGURATIONS,
      carePrincipalId: action.carePrincipalId,
    });
    toast.success(String(i18n.t("toasts.jobConfigurationUpdated")));
  } catch (error) {
   yield handleError(error);
  }
}

// COMFACT - KOMMER ATT TAS BORT 
// export function* handleUpdateAllowedContracts(action: any): any {
//   try {
//     const carePrincipalAdminClient = setUpClient();
//     yield carePrincipalAdminClient.updateAllowedContracts(
//       action.carePrincipalId,
//       action.list
//     );
//     yield put({
//       type: GET_ALLOWED_CONTRACTS,
//       carePrincipalId: action.carePrincipalId,
//     });
//     toast.success(i18n.t("toasts.signListUpdated"));
//   } catch (error) {
//     yield handleError(error);
//   }
// }

export function* handleDeleteCarePrincipalAccess(action: any): any {
  try {
    yield put({ type: MODAL_CONFIRM });
    const carePrincipalAdminClient = setUpClient();
    yield carePrincipalAdminClient.deleteCarePrincipalAccess(
      action.carePrincipalId,
      action.listItem.id
    );

    yield put({
      type: GET_CARE_PRINCIPAL_ACCESS,
      carePrincipalId: action.carePrincipalId,
    });
    getSuccessToast(i18n.t("toasts.carePrincipalAccessDeleted"));
  } catch (error) {
   yield handleError(error);
  }
}

export function* handleGetCarePrincipalAccess(action: any): any {
  try {
    const carePrincipalAdminClient = setUpClient();
    const response = yield carePrincipalAdminClient.getCarePrincipalAccess(
      action.carePrincipalId
    );
    yield put(setCarePrincipalAccess(response));
  } catch (error) {
   yield handleError(error);
  }
}

export function* handleAddCarePrincipalAccess(action: any): any {
  try {
    const carePrincipalAdminClient = setUpClient();
    yield carePrincipalAdminClient.addCarePrincipalAccess(
      action.carePrincipalId,
      action.newAccess.idType,
      action.newAccess
    );
    yield put({
      type: GET_CARE_PRINCIPAL_ACCESS,
      carePrincipalId: action.carePrincipalId,
    });    
    getSuccessToast(i18n.t("toasts.carePrincipalAccessAdded"));
  } catch (error) {
   yield handleError(error);
  }
}

export function* handleGetCarePrincipalSettings(action: any): any {
  try {
    const carePrincipalAdminClient = setUpClient();
    const response = yield carePrincipalAdminClient.getCarePrincipalSettings(
      action.carePrincipalId
    );
    yield put(setCarePrincipalsSettings(response));
  } catch (error) {
   yield handleError(error);
  }
}

export function* handleGetConnectedCarePrincipals(action: any): any {
  try {
    const carePrincipalClient = setUpCarePrincipalClient();
    const response =
      yield carePrincipalClient.getCarePrincipalsForAuthorizedEntity(
        action.authorizedEntity
      );
    yield put(setConnectedCarePrincipals(response));
  } catch (error) {
   yield handleError(error);
  }
}

export function* handleSaveCareUnitSettings(action: any): any {
  try {
    const carePrincipalAdminClient = setUpClient();
    yield carePrincipalAdminClient.addCareUnitSettings(
      action.careUnitId,
      action.settings
    );
    const careUnitId = action.careUnitId;
    const carePrincipals = action.carePrincipals;
    yield put({ type: GET_CARE_UNIT_SETTINGS, careUnitId, carePrincipals });
    getSuccessToast(i18n.t("toasts.addCareUnitSetting"));
  } catch (error) {
   yield handleError(error);
  }
}

export function* handleDeleteCareUnitSettings(action: any): any {
  try {
    const carePrincipalAdminClient = setUpClient();
    yield carePrincipalAdminClient.deleteCareUnitSettings(action.careUnit);
    yield put({
      type: GET_CARE_UNIT_SETTINGS,
      careUnitId: store.getState().session.currentUser.healthCareUnitHsaId,
      carePrincipals: action.carePrincipals,
    });
    getSuccessToast(i18n.t("toasts.removeCareUnitSetting"));
  } catch (error) {
    yield handleError(error);
  }
}
